package top.wcpe.allincore.ui.runtime.internal.time

import kotlin.js.Date

/** JS：Date.now() 毫秒时钟。 */
internal actual fun currentTimeMillis(): Long = Date.now().toLong()

/**
 * JS：以 Date.now() 折算纳秒。仅毫秒精度（JS 端不启用帧渲染性能埋点，精度损失无影响），
 * 满足 nanoTime 契约「仅表达时间差」的最低要求。
 */
internal actual fun nanoTime(): Long = Date.now().toLong() * 1_000_000L
